module.exports = __webpack_public_path__ + "img/border_Ring2.c1915051.svg";